import { FormGeneratorLookupService }   from '@cs/components/form-generator-nxt';
import { CsHttpRequestOptions, Result } from '@cs/core';
import { ReportingService }             from '@cs/customer/api/api/reporting.service';
import { map }                          from 'rxjs/operators';

export class DashboardFormGeneratorLookupService extends FormGeneratorLookupService {
	constructor(private lookupService: ReportingService) {
		super();
	}

	getLookupWithFilter(lookupName: string, formDetails: any, contextObject: any = {}, csHttpRequestOptions: CsHttpRequestOptions = null) {
		return this.lookupService.reportingDashboardLookupWithFilterPost(lookupName, JSON.stringify(formDetails), JSON.stringify(contextObject), csHttpRequestOptions);
	}

	dependantFieldHasChanged(changedFieldId: string, formDetails: any, contextObject: any, csHttpRequestOptions?: CsHttpRequestOptions) {
		throw new Error('Method not implemented.');
	}


}

